import { Pie } from "@ant-design/charts"

type DoughnutChartData = {
  type: string
  value: number
}

export type Props = {
  data: DoughnutChartData[]
}

const DoughnutChart = ({ data }: Props) => {
  if (data.length <= 0) {
    return <></>
  }

  const config = {
    height: 300,
    width: 440,
    data: data,
    angleField: 'value',
    colorField: 'type',
    innerRadius: 0.6,
    style: {
      stroke: '#fff',
      inset: 1,
    },
    tooltip: {
      title: 'type',
    },
    legend: { color: { position: 'bottom' } },
    scale: { color: { palette: "category10" } },
  }

  return <Pie {...config} />
}

export default DoughnutChart